import React, { useState } from 'react';
import styled from 'styled-components';
import DOMPurify from 'isomorphic-dompurify';
import AccordianToggleIcon from 'images/shared/AccordianToggleIcon';
import SVGMapper from 'images/service-pages/event-and-conferences/dropdown-svgs/SVGMapper';

const AccordianItem = ({ i, expanded, setExpanded, item }) => {
  const isOpen = i === expanded;
  const SVGIcon = SVGMapper[item.icon];


  return (
    <Item role="button" onClick={() => setExpanded(isOpen ? null : i)} isOpen={isOpen}>
      <Title isOpen={isOpen}>
        {item.title}
        <AccordianToggleIcon isOpen={isOpen} />
      </Title>
      <Content isOpen={isOpen}>
        <SVGContainer>
          {SVGIcon ? <SVGIcon /> : <div />}
        </SVGContainer>
        <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item.moreInfo) }} />
      </Content>
    </Item>
  );
};

const ServiceAccordian = ({ items }) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Container>
      {items.map((item) => (
        <AccordianItem
          i={item.id}
          key={`${item.id} + ${item.title}`}
          expanded={expanded}
          setExpanded={setExpanded}
          item={item}
        />
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1rem;
  border-bottom: 1px solid #c1beac;
  cursor: pointer;
  p {
    font-size: 1.25rem;
  }
`;

const Title = styled.h4`
  font-size: 1.25rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-between;
  svg {
    height: 1.5rem;
    width: 1.5rem;
  }
  color: ${({ isOpen }) => (isOpen ? `var(--ax-black)` : `var(--ax-gold)`)};
  transition: 150ms ease-in-out;
  @media (min-width: 64rem) {
    font-size: 1.5rem;
  }
`;

const Content = styled.div`
  font-weight: 400;
  color: var(--ax-black);
  display: grid;
  grid-template-rows: 120px 1fr;
  gap: 1.25rem;
  overflow: hidden;
  max-height: ${({ isOpen }) => (isOpen ? '1000px' : '0')};
  opacity: ${({ isOpen }) => (isOpen ? '1' : '0')};
  margin: ${({ isOpen }) => (isOpen ? '1rem 0' : '0')};
  transition: all 0.375s cubic-bezier(0.04, 0.62, 0.23, 0.98);
  p {
    font-size: 1rem !important;
  }
  @media (min-width: 64rem) {
    gap: 3rem;
    grid-template-rows: 1fr;
    grid-template-columns: 160px 1fr;
    p {
      font-size: 1.25rem !important;
    }
  }
`;

const SVGContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  svg {
    max-width: 80px;
    width: 100%;
    height: 100%;
  }
  @media (min-width: 64rem) {
    justify-content: flex-end;
    svg {
      max-width: 120px;
    }
  }
`;

export default ServiceAccordian;
